import React from "react";
// import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
// import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

export default function Features() {
  return (
    <CardContent>
      <Typography variant="body1" color="primary" component="h2">
        Scan Anything
      </Typography>
      <Typography variant="body2" component="p">
        Scan Anywhere,Anything,Anytime . <b> BharatDocumentScanner </b>once
        installed can turn every smartphone into a portable scanners.
        <br />
        <br />
        <br />
      </Typography>
      <Typography variant="body1" color="primary" component="h2">
        Data Security
      </Typography>
      <Typography variant="body2" component="p">
        Your data belongs to you. <b> BharatDocumentScanner </b>is extremely
        secure and keeps all the data on your own device.
        <br />
        <br />
        <br />
      </Typography>
      <Typography variant="body1" color="primary" component="h2">
        PDF Creator
      </Typography>
      <Typography variant="body2" component="p">
        <b> BharatDocumentScanner </b>
        Easily converts scanned images to the best quality PDF file.
      </Typography>
    </CardContent>
  );
}
